import Wrap from '../../../components/wrap'

export default function Platform() {

    return (
        <section className="platform-description-section bg-platform-advertisers">
            <Wrap>
                <div>
                    <h2 className="section-title"><span className="text-primary">Pixad</span> is a platform that offers advertising solutions in all advertising spaces for content creator websites and applications.</h2>
                    <p className="section-desc text-black">Ad inventory optimization: Pixad helps publishers maximize the value of their ad inventory. Pixad includes automatic bid optimization and ad placement strategies to fill ad spaces with the most lucrative advertisements.</p>
                </div>
            </Wrap>
        </section>
    )
}